
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"120","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"4","y":"4","width":"92","height":"112","rx":"4","fill":"#fff"}}),_c('rect',{attrs:{"x":"2","y":"2","width":"96","height":"116","rx":"6","stroke":"#C2C2C2","stroke-opacity":".18","stroke-width":"4"}}),_c('rect',{attrs:{"x":"4","y":"4","width":"92","height":"112","rx":"4","fill":"#fff"}}),_c('rect',{attrs:{"x":"3","y":"3","width":"94","height":"114","rx":"5","stroke":"#C2C2C2","stroke-opacity":".18","stroke-width":"2"}}),_c('rect',{attrs:{"x":"3.5","y":"3.5","width":"93","height":"113","rx":"4.5","stroke":"#C2C2C2","stroke-opacity":".4"}}),_c('path',{attrs:{"opacity":".8","d":"M84.94 10.075l6.916 5.148a.335.335 0 010 .553l-6.909 5.149a.374.374 0 01-.385.04.36.36 0 01-.15-.128.338.338 0 01-.056-.186v-3.399h-7.989a.361.361 0 01-.367-.35v-2.803c0-.093.04-.182.108-.248a.378.378 0 01.26-.103h7.981v-3.4c.003-.288.351-.453.592-.273z","fill":"#39AE61"}}),_c('path',{attrs:{"opacity":".8","d":"M16.06 10.075l-6.916 5.148a.335.335 0 000 .553l6.909 5.149a.374.374 0 00.385.04.36.36 0 00.15-.128.338.338 0 00.056-.186v-3.399h7.989a.361.361 0 00.367-.35v-2.803a.345.345 0 00-.108-.248.378.378 0 00-.26-.103h-7.981v-3.4c-.003-.288-.351-.453-.592-.273z","fill":"#F39"}}),_c('path',{attrs:{"opacity":".3","fill":"#9AA5BB","fill-opacity":".75","d":"M14 60h68v4H14zM14 68h40v4H14zM14 52h59v4H14z"}})])
          )
        }
      }
    